import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberRoute } from '../lib/lastRoute.js';

// Records the current in-app location so Landing can restore it on the next
// cold launch. Renders nothing; isolated so only it re-renders on navigation.
export default function RouteMemory() {
  const { pathname } = useLocation();
  useEffect(() => { rememberRoute(pathname); }, [pathname]);
  return null;
}
